import { render, staticRenderFns } from "./commonSearch.vue?vue&type=template&id=67b920f2&scoped=true"
import script from "./commonSearch.vue?vue&type=script&lang=js"
export * from "./commonSearch.vue?vue&type=script&lang=js"
import style0 from "./commonSearch.vue?vue&type=style&index=0&id=67b920f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b920f2",
  null
  
)

export default component.exports